import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const TITLE_MAP: Record<string, string> = {
  '/': 'Jen | Next-Jeneration Music Creation',
  '/recharge': 'Pricing | Jen',
};

export const PageTitle: React.FC = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const getTitle = () => {
    if (pathname.startsWith('/recharge/')) {
      return 'Pricing | Jen';
    }

    return TITLE_MAP[pathname] || 'Jen | Next-Jeneration Music Creation';
  };

  return (
    <Helmet>
      <title>{getTitle()}</title>
    </Helmet>
  );
};
